/* @flow */

import getTokenApi from '../login/get-token-api';

const headersApi = () => ({
    Accept: 'application/json',
    Authorization: getTokenApi(),
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
});


export default headersApi;
